import React from 'react';
import Link from 'gatsby-link';
import styles from './header.module.scss';
import logo from './logo-red.png';

const Header = () => (
  <div className={styles.header}>
    <nav id="menu" className="menu">
      <ul>
        <li className={styles.brand}>
          <img src={logo} />
          <Link to="#menu" className={styles.link}> Dapis</Link>
        </li>
        <li><Link to="#fullstack" className={styles.link}> Full Stack Template</Link></li>
        <li><Link to="#dblog" className={styles.link}> dBlog</Link></li>
        <li><Link to="#proof" className={styles.link}> Project Proof</Link></li>
      </ul>
    </nav>
  </div>
)

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js